import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Despre from "@/pages/Despre";
import CeOferim from "@/pages/CeOferim";
import CampaniiCustom from "@/pages/CampaniiCustom";
import Contact from "@/pages/Contact";
import Partner from "@/pages/Partner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/despre-noi" element={<Despre />} />
            <Route path="/ce-oferim" element={<CeOferim />} />
            <Route path="/campanii-custom" element={<CampaniiCustom />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/:slug" element={<Partner />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
